import React from 'react';

const ManageChat = () => {
  return (
    <div className="page-content">
      <h2>Manage Chat</h2>
      <p>This is a dummy page for managing chat.</p>
    </div>
  );
};

export default ManageChat;
